import React from 'react'
import MainBlock from './MainBlock/MainBlock'
import StatsBlock from './StatsBlock/StatsBlock'
import AboutBlock from './AboutBlock/AboutBlock'
import TypesBlock from './TypesBlock/TypesBlock'
import FeaturedBlock from './FeaturedBlock/FeaturedBlock'
import Form from '../../Modules/Form/Form'

const Roofing = () => {
  return (
    <div>
      <MainBlock />
      <StatsBlock />
      <AboutBlock />
      <TypesBlock />
      <FeaturedBlock />
      <Form />
    </div>
  )
}

export default Roofing